export function ShowLoader() {
    // tslint:disable-next-line:ban-types
    return (Class: Function) => {
        Object.defineProperty(Class.prototype, 'showLoader', {
            value: true
        });
    };
}
